<template>
	<v-main v-if="$store.getters.checkModulePermissions('calendar')">
		<v-navigation-drawer
			app
			fixed
			clipped
			width="290"
			v-model="drawer"
			class="background-2 yello-calendar"
			:class="$vuetify.theme.dark ? 'dark-calendar' : 'calendar'">

			<div class="text-center pa-3">
				<v-select
					v-if="$vuetify.breakpoint.xs"
					v-model="type"
					:items="typeOptions"
					item-text="text"
					item-value="value"
					label="Tipo"
					dense
					background-color="background-2"
					hide-details
					flat
					solo
					:menu-props="{'offset-y': true}"
				></v-select>
			</div>

			<div class="text-center py-3">
				<event-button-dialog
					:params="{
						'rounded': true,
						'text': 'Crea Evento',
						'button_color': 'primary',
						'create': true,
					}"
				></event-button-dialog>
			</div>
			<gmh-date-picker
				inline
				v-model="today"
				@change="getEvents()"
				@input="getEvents()"
				:picker-props="{ 'no-title': true, flat: true, reactive: true, class: 'elevation-0' }"
			></gmh-date-picker>

			<!-- Event Filters Section -->
			<v-expansion-panels flat class="mt-3 mb-2" v-model="filterPanelOpen">
				<v-expansion-panel class="background-2">
					<v-expansion-panel-header class="pa-3">
						<template v-slot:default="{ open }">
							<v-row no-gutters align="center">
								<v-col>
									<div class="subtitle-2">Filtri Eventi</div>
									<div class="caption" v-if="activeFiltersCount > 0">
										{{ activeFiltersCount }} {{ activeFiltersCount === 1 ? 'filtro attivo' : 'filtri attivi' }}
									</div>
								</v-col>
							</v-row>
						</template>
					</v-expansion-panel-header>
					
					<v-expansion-panel-content>
						<!-- Event Type Filter -->
						<div class="px-0 pb-3 mx-n2">
							<v-subheader class="px-0 subtitle-2">Tipo Evento</v-subheader>
							<v-select
								v-model="selectedEventTypes"
								:items="eventTypes"
								item-text="text"
								item-value="value"
								label="Seleziona tipi evento"
								multiple
								chips
								small-chips
								deletable-chips
								dense
								outlined
								hide-details
								clearable
								class="mt-2"
								:menu-props="{'offset-y': true}">
								<template v-slot:selection="{ item, index }">
									<v-chip
										v-if="index < 2"
										small
										close
										@click:close="removeEventType(item)"
										color="primary"
										text-color="white">
										{{ item.text }}
									</v-chip>
									<span v-if="index === 2" class="caption">
										(+{{ selectedEventTypes.length - 2 }} altri)
									</span>
								</template>
							</v-select>
						</div>
						
						<!-- Eventable Type Filter -->
						<div class="px-0 pb-2 mx-n2">
							<v-subheader class="px-0 subtitle-2">Tipo Entità</v-subheader>
							<v-chip-group
								v-model="selectedEventableTypes"
								multiple
								column
								active-class="primary primary--text">
								<v-chip
									v-for="type in eventableTypeOptions"
									:key="type.value"
									:value="type.value"
									small
									outlined
									filter>
									<v-icon left small>{{ type.icon }}</v-icon>
									{{ type.label }}
								</v-chip>
							</v-chip-group>
						</div>
						
						<!-- Quick Actions -->
						<v-divider class="mb-2 mx-n2"></v-divider>
						<div class="px-0 pb-2 d-flex justify-space-between">
							<v-btn
								text
								small
								@click="clearFilters"
								:disabled="!hasActiveFilters">
								<v-icon small left>mdi-filter-remove</v-icon>
								Rimuovi filtri
							</v-btn>
							<v-btn
								text
								small
								color="primary"
								@click="applyFilters">
								<v-icon small left>mdi-check</v-icon>
								Applica
							</v-btn>
						</div>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>

			<!-- Improved Entity Card -->
			<div class="ma-0 px-3 pb-2" v-if="loadedEventable">
				<eventable-entity-card
					:eventable="eventable"
					:eventable-type="eventParams.eventable_type"
					@remove="removeEventable"
				/>
			</div>

			<v-row class="ma-0 d-block px-4 pt-1">
				<v-subheader class="pl-0">Calendari disponibili</v-subheader>
				<v-checkbox label="Seleziona tutti" class="mt-0" color="primary" hide-details ripple v-model="selectAll"></v-checkbox>
				<v-divider class="my-2"></v-divider>
				<template v-for="(calendar, c) in calendars">
					<v-checkbox :label="calendar.name" class="mt-0" :color="calendar.color" hide-details ripple v-model="selectedCalendars" :value="calendar.id" :key="c"></v-checkbox>
				</template>
			</v-row>

			<v-row class="ma-0 d-block px-4 pt-4">
				<v-subheader class="pl-0">Calendari condivisi</v-subheader>
				<template v-for="(calendar, c) in sharedCalendars">
					<v-checkbox :label="calendar.name" class="mt-0" :color="calendar.color" hide-details ripple v-model="selectedCalendars" :value="calendar.id" :key="c"></v-checkbox>
				</template>
				<span v-if="sharedCalendars.length == 0" class="caption">Nessuno</span>
			</v-row>
			
			<v-row class="ma-0 d-block px-4 pt-4" v-if="$store.getters.checkModulePermissions('timecards')">
				<v-subheader class="pl-0">Calendario Timecard</v-subheader>
				<v-checkbox label="Timecard" class="mt-0" color="#ffc61a" hide-details ripple v-model="timecardCalendar"></v-checkbox>
			</v-row>

			<v-row class="ma-0 d-block px-4 pt-4" v-if="$store.getters.checkModulePermissions('tickets') || $store.getters.checkModulePermissions('helpdesk')">
				<v-subheader class="pl-0">Calendario Interventi</v-subheader>
				<v-checkbox label="Interventi" class="mt-0" color="#1976d2" hide-details ripple v-model="interventionCalendar"></v-checkbox>
			</v-row>
		</v-navigation-drawer>

		<v-app-bar
			v-if="$store.getters.isAuthenticated"
			class="elevation-2"
			:class="$eventBusUtility.iconAppBarColor"
			:color="headerColor"
			clipped-left
			app>
			<v-btn
				icon
				class="ml-0 mr-1"
				v-if="$store.getters.isAuthenticated"
				@click.stop="drawer = !drawer" >
				<v-icon :class="$eventBusUtility.iconAppBarColor">menu</v-icon>
			</v-btn>
			<template v-if="!$vuetify.breakpoint.xs">
				<v-img
					class="ml-2"
					:src="logo"
					contain
					height="36px"
					max-height="36px"
					max-width="40px"
				></v-img>     
				<span class="title ml-2 hidden-xs-only"><span class="fw300">{{ title }}</span></span>			
			</template>
			<span v-else class="mr-4">{{ formatCurrentMonth }}</span>

			<v-spacer></v-spacer>
			<v-tooltip bottom>
                <template v-slot:activator="{ on }">
				    <v-btn small v-on="on" text icon :class="$eventBusUtility.iconAppBarColor" class="mr-4" @click="goBack()" dark><v-icon>mdi-home-outline</v-icon></v-btn>
                </template>
				<span>Indietro</span>
			</v-tooltip>  
			<v-tooltip bottom>
                <template v-slot:activator="{ on }">
				    <v-btn v-on="on" outlined :class="$eventBusUtility.iconAppBarColor" @click="setToday()" slot="activator">Oggi</v-btn>
                </template>
                <span>Oggi</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" @click="prev()" text small icon class="ml-4 mr-1">
						<v-icon :class="$eventBusUtility.iconAppBarColor">keyboard_arrow_left</v-icon>
					</v-btn>
				</template>
				<span>Precedente</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" @click="next()" text small icon class="mr-4 ml-1">
						<v-icon :class="$eventBusUtility.iconAppBarColor">keyboard_arrow_right</v-icon>
					</v-btn>
				</template>
				<span>Successiva</span>
			</v-tooltip>	

			<template v-if="!$vuetify.breakpoint.xs">
				<gmh-date-picker
					v-if="!drawer"
					v-model="today"
					@change="getEvents()"
					@input="getEvents()"
					:show-today="false"
					>
					<!-- il campo mostra il mese corrente, non la data selezionata -->
					<template v-slot:activator="{ on }">
						<v-text-field
							v-on="on"
							readonly flat solo dense
							background-color="background-2"
							append-icon="arrow_drop_down"
							:value="formatCurrentMonth"
							hide-details
						></v-text-field>
					</template>
				</gmh-date-picker>
				<v-text-field v-else
					readonly flat solo dense
					background-color="background-2"
					:value="formatCurrentMonth"
					hide-details
				></v-text-field>
			</template>		

			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
			<div class="mx-3 mr-4">
				<v-progress-circular
					:size="30"
					v-show="loadEvents"
					indeterminate
					:class="$eventBusUtility.iconAppBarColor"
					:width="3"
				></v-progress-circular>
			</div>
			<v-select
				v-if="!$vuetify.breakpoint.xs"
				v-model="type"
				:items="typeOptions"
				item-text="text"
				item-value="value"
				label="Tipo"
				dense
				background-color="background-2"
				hide-details
				flat
				solo
				:menu-props="{'offset-y': true}"
			></v-select>

			<template v-if="!$vuetify.breakpoint.xs">
				
				<color-mode @colorModeChanged="setLogo"></color-mode>

				<notifications-menu
					:archive="false"
				></notifications-menu>
		
			</template>

		</v-app-bar>

		<!-- Mobile Filter FAB -->
		<v-btn
			v-if="$vuetify.breakpoint.xs"
			fab
			fixed
			bottom
			right
			color="primary"
			@click="mobileFilterSheet = true"
			class="mb-16 mr-4"
			style="z-index: 5">
			<v-badge
				v-if="activeFiltersCount > 0"
				:content="activeFiltersCount"
				color="error"
				overlap>
				<v-icon>mdi-filter</v-icon>
			</v-badge>
			<v-icon v-else>mdi-filter</v-icon>
		</v-btn>

		<!-- Mobile Bottom Sheet -->
		<v-bottom-sheet v-model="mobileFilterSheet" scrollable>
			<v-sheet class="pa-4" height="60vh">
				<div class="d-flex justify-space-between align-center mb-4">
					<h3 class="headline">Filtri Eventi</h3>
					<v-btn icon @click="mobileFilterSheet = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div>
				
				<!-- Event Type Filter -->
				<div class="mb-4">
					<v-subheader class="px-0 subtitle-1">Tipo Evento</v-subheader>
					<v-select
						v-model="selectedEventTypes"
						:items="eventTypes"
						item-text="text"
						item-value="value"
						label="Seleziona tipi evento"
						multiple
						chips
						small-chips
						deletable-chips
						outlined
						hide-details
						clearable
						:menu-props="{'offset-y': true}"
					></v-select>
				</div>
				
				<!-- Eventable Type Filter -->
				<div class="mb-4">
					<v-subheader class="px-0 subtitle-1">Tipo Entità</v-subheader>
					<v-chip-group
						v-model="selectedEventableTypes"
						multiple
						column
						active-class="primary primary--text">
						<v-chip
							v-for="type in eventableTypeOptions"
							:key="type.value"
							:value="type.value"
							outlined
							filter>
							<v-icon left>{{ type.icon }}</v-icon>
							{{ type.label }}
						</v-chip>
					</v-chip-group>
				</div>
				
				<!-- Actions -->
				<v-divider class="mb-4"></v-divider>
				<div class="d-flex justify-space-between">
					<v-btn
						text
						@click="clearFilters(); mobileFilterSheet = false"
						:disabled="!hasActiveFilters">
						<v-icon left>mdi-filter-remove</v-icon>
						Rimuovi filtri
					</v-btn>
					<v-btn
						color="primary"
						@click="applyFilters(); mobileFilterSheet = false">
						<v-icon left>mdi-check</v-icon>
							Applica
					</v-btn>
				</div>
			</v-sheet>
		</v-bottom-sheet>

		<v-row class="ma-0">
			<v-col cols="12" class="pa-0">
				<v-sheet style="height: calc(100vh - 64px);">
					<v-calendar
						ref="calendar"
						v-model="today"
						color="primary"
						:type="calendarType"
						locale="It"
						:weekdays="calendarWeekdays"
						:short-intervals="true"		
						interval-height="50"
						:class="{'open-nav': drawer}"	
						event-overlap-mode="stack"
						event-end="ended_at"
						event-start="started_at"
						:events="calendarEvents"
						:event-color="getEventColor"
						:event-ripple="true"
						@change="getEvents"
						@click:event="showEvent"
						@click:more="viewDay"
						@click:date="handleDateClick"
						@click:day="handleDayClick"
						@mousedown:event="startDrag"
						@mousedown:time="startTime"
						@mousemove:time="mouseMove"
						@mouseup:time="endDrag"
						@mouseleave.native="cancelDrag">
						<template v-slot:event="{ event, timed }">
							<div class="v-event-draggable" :class="{'past-event': isPastEvent(event)}" :style="getEventTextColor(event)">
								<div :id="event.id" :key="event.id">
									<div :id="event.id" class="event-title">
										<span v-if="event.event_type">[{{ getEventTypeText(event.event_type) }}] </span>{{ event.name }}
									</div>
									<div :id="event.id" class="event-schedule" :class="durationMinutes(event.started_at, event.ended_at) > 30 ? 'd-block' : ''">{{ formatTimeFromTo(event) }}</div>
								</div>
							</div>
							<div
								v-if="timed && hasPermissions(event)"
								class="v-event-drag-bottom"
								@mousedown.stop="extendBottom(event)"
							></div>
						</template>
						<template v-slot:day-body="{ date, week }">
							<div
								v-if="isToday(date)"
								class="v-current-time"
								:class="{ first: true }"
								:style="{ top: nowY }"
							></div>
						</template>
					</v-calendar>

					<v-menu
						v-if="selectedOpen"
						@click.native.stop
						width="400px"
						max-width="400px"
						v-model="selectedOpen"
						:close-on-content-click="false"
						:close-on-click="false"
						:activator="selectedElement"
						content-class="round-card"
						offset-x>
						<v-card width="400px" :class="menuClass" class="background-2">
							<v-card-title class="pt-2 pr-2 pa-0">
								<v-spacer></v-spacer>
								<event-button-dialog v-if="selectedEvent.id > 0 && hasPermissions(selectedEvent) && !selectedEvent.event_id"
									:params="{
										'icon_name': 'edit',
										'fab': false,
										'edit': true,
										'icon': true
									}"
									:model="selectedEvent"
								></event-button-dialog>		
								<v-tooltip top>
									<template v-slot:activator="{ on }">
										<v-btn v-on="on" text icon v-if="selectedEvent.id > 0" @click="copyInClipboard(selectedEvent)">
											<v-icon>mdi-content-copy</v-icon>
										</v-btn>
									</template>
									<span>Copia in Clipboard</span>
								</v-tooltip>
								<v-tooltip top v-if="hasPermissions(selectedEvent) && !selectedEvent.event_id">
									<template v-slot:activator="{ on }">
										<v-btn v-on="on" text icon v-if="selectedEvent.id > 0" @click="deleteEvent(selectedEvent)">
											<v-icon>delete</v-icon>
										</v-btn>
									</template>
									<span>Elimina</span>
								</v-tooltip>
								<v-tooltip top>
									<template v-slot:activator="{ on }">                                                
										<v-btn v-if="selectedEvent.id > 0" text v-on="on" icon @click="closeMenu()">
											<v-icon>close</v-icon>
										</v-btn>
										<v-btn v-else text v-on="on" icon @click="deleteAndClose(selectedEvent)">
											<v-icon>close</v-icon>
										</v-btn>
									</template>
									<span>Chiudi</span>
								</v-tooltip>
							</v-card-title>							
							<v-list two-line dense class="background-2 pa-0 pb-3">
								<v-list-item>
									<template v-if="selectedEvent.id > 0">
										<v-list-item-avatar class="mr-2 my-0">
											<div class="monthly-event-menu-pin" :style="{'background-color': selectedEvent.calendar ? selectedEvent.calendar.color : ''}"></div>
										</v-list-item-avatar>
										<v-list-item-content>
											<v-list-item-title>{{ selectedEvent.name }}</v-list-item-title>
											<v-list-item-subtitle class="capitalize">{{ formatEventDate(selectedEvent) }}</v-list-item-subtitle>
										</v-list-item-content>
									</template>
									<template v-else>
										<v-text-field class="pl-12 pt-0"
											:autofocus="true"
											placeholder="Aggiungi titolo"
											v-model="selectedEvent.name"
										></v-text-field>
									</template>
								</v-list-item>
								<v-list-item v-if="selectedEvent.id <= 0">
									<v-list-item-action>
										<v-icon color="primary">event</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-checkbox
											v-model="selectedEvent.allday"
											label="Tutto il giorno"
											hide-details
											class="mt-0"
											@change="updateEventAllDay"
										></v-checkbox>
									</v-list-item-content>
								</v-list-item>
								<v-list-item>
									<v-list-item-action>
										<v-icon color="primary">today</v-icon>
									</v-list-item-action>
									<v-list-item-content v-if="selectedEvent.id > 0">
										<v-list-item-title>Calendario</v-list-item-title>
										<v-list-item-subtitle>{{ selectedEvent.calendar ? selectedEvent.calendar.name : '' }}</v-list-item-subtitle>
									</v-list-item-content>
									<v-list-item-content v-else>
										<v-list-item-title>Calendario</v-list-item-title>
										<v-list-item-subtitle class="ml-n3">
											<v-autocomplete
												v-model="selectedEvent.calendar_id"
												:items="selectEventCalendars"
												item-text="name"
												item-value="id"
												label="Calendario"
												hide-details
												flat
												dense
												solo
												background-color="background-2">
												<template v-slot:item="data">
													<v-list-item-avatar class="ml-n4 mr-0">
														<v-icon :color="data.item.color">fiber_manual_record</v-icon>
													</v-list-item-avatar>
													<v-list-item-content>
														<v-list-item-title>{{ data.item.name }}</v-list-item-title>
														<v-list-item-subtitle v-html="data.item.type"></v-list-item-subtitle>
													</v-list-item-content>
												</template>
											</v-autocomplete>
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-if="selectedEvent.id > 0 && selectedEvent.event_type">
									<v-list-item-action>
										<v-icon color="primary">label</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Tipo Evento</v-list-item-title>
										<v-list-item-subtitle>{{ getEventTypeText(selectedEvent.event_type) }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-if="selectedEvent.id <= 0">
									<v-list-item-action>
										<v-icon color="primary">person</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Invitati</v-list-item-title>
										<v-list-item-subtitle class="ml-n3">
											<v-combobox
												label="Aggiungi Invitati"
												:items="users"
												v-model="selectedEvent.users"
												multiple
												return-object
												clearable
												data-vv-name="Invitati"
												solo flat dense
												background-color="background-2">
												<template v-slot:selection="data">
													<v-chip
														v-bind="data.attrs"
														:input-value="data.selected"
														close
														multiple
														small
														pill
														@click="data.select">
														<v-avatar v-if="data.item.avatar" left>
															<v-img :src="data.item.avatar"></v-img>
														</v-avatar>			
														<v-avatar v-else
															left
															style="height: 24px !important; width: 24px !important"
															class="primary white--text">
															{{ data.item['text'] ? data.item['text'].slice(0, 1).toUpperCase() : ''}}
														</v-avatar>
														<div class="xs3 string-cutter">{{ data.item['text'] }}</div>
													</v-chip>
												</template>
												<template v-slot:item="data">
													<template>
														<v-list-item-avatar v-if="data.item.avatar" style="margin-right: 10px;">
															<v-avatar
																class="custom-avatar"
																:size="34" 
																:style="{'background-image': 'url(' + data.item.avatar + ')'}">
															</v-avatar>
														</v-list-item-avatar>
														<v-list-item-avatar v-else
															:size="34"
															style="min-width: 34px; width: 34px; height:34px; border-radius: 50%"
															class="primary mr-4">
															<span style="color: white !important" class="margin-auto">{{ data.item.text ? data.item.text.slice(0, 1).toUpperCase() : ''}}</span>
														</v-list-item-avatar>
														<v-list-item-content>
															<v-list-item-title>{{ data.item.text }}</v-list-item-title>
															<v-list-item-subtitle>
																<span>{{ data.item.subtitle }}</span>
															</v-list-item-subtitle>
														</v-list-item-content>
													</template>
												</template>											
											</v-combobox>
										</v-list-item-subtitle>
										<v-alert
											v-if="eventableUsersWithoutCalendar.length"
											type="warning"
											dense
											text
											class="mt-2 mb-0 caption">
											{{ eventableUsersWithoutCalendar.map(u => u.text).join(', ') }}
											{{ eventableUsersWithoutCalendar.length === 1 ? 'non ha' : 'non hanno' }} un calendario e {{ eventableUsersWithoutCalendar.length === 1 ? 'non può' : 'non possono' }} essere {{ eventableUsersWithoutCalendar.length === 1 ? 'aggiunto' : 'aggiunti' }} come {{ eventableUsersWithoutCalendar.length === 1 ? 'invitato' : 'invitati' }}
										</v-alert>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-if="selectedEvent.id <= 0">
									<v-list-item-action>
										<v-icon color="primary">label</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Tipo Evento</v-list-item-title>
										<v-list-item-subtitle class="ml-n3">
											<v-select
												label="Aggiungi tipo evento"
												:items="eventTypes"
												v-model="selectedEvent.event_type"
												item-text="text"
												item-value="value"
												clearable
												solo
												flat
												dense
												:menu-props="{'offset-y': true}"
												background-color="background-2">
											</v-select>
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-if="selectedEvent.creator">
									<v-list-item-avatar class="my-0 mr-2">
										<v-avatar v-if="$store.getters.avatars[selectedEvent.user_id]"
											:size="28"
											class="avatar-event"
											:style="{'background-image': 'url(' + $store.getters.avatars[selectedEvent.user_id] + ')'}">
										</v-avatar>
										<v-avatar v-else :class="$eventBusUtility.bgColor(selectedEvent.user_id)" :size="30" class="custom-avatar-table">
											<span class="white--text fs12 " v-if="selectedEvent.user_id">{{ selectedEvent.creator.charAt(0) }}</span>
										</v-avatar>
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title>Creatore</v-list-item-title>
										<v-list-item-subtitle v-html="selectedEvent.creator"></v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-if="selectedEvent.vehicles && selectedEvent.vehicles.length">
									<v-list-item-action>
										<v-icon color="primary">mdi-car</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Veicoli</v-list-item-title>
										<v-list-item-subtitle>
											<v-chip v-for="v in selectedEvent.vehicles" :key="v.id" x-small class="mr-1 mb-1">
												{{ v.text }}
											</v-chip>
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-if="selectedEvent.description">
									<v-list-item-action>
										<v-icon color="primary">note</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Descrizione</v-list-item-title>
										<v-list-item-subtitle v-html="selectedEvent.description"></v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<!-- Dynamic Eventable Details Component -->
								<eventable-details 
									v-if="selectedEvent.eventable_type && selectedEvent.id > 0"
									:event="selectedEvent"
								/>
								<template v-if="selectedEvent.users && selectedEvent.users.length > 0">
									<v-list-item>
										<v-list-item-action>
											<v-icon color="primary">people_outline</v-icon>
										</v-list-item-action>
										<v-list-item-content>
											<v-list-item-title>{{ selectedEvent.users.length }} Invitati</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-list-item v-for="(user, u) in selectedEvent.users" :key="u">
										<v-list-item-avatar class="my-0 mr-2">
											<v-avatar v-if="$store.getters.avatars[user.value]"
												:size="30"
												class="avatar-event"
												:style="{'background-image': 'url(' + $store.getters.avatars[user.value] + ')'}">
											</v-avatar>
											<v-avatar v-else :class="$eventBusUtility.bgColor(user.value)" :size="30" class="custom-avatar-table" :key="u">
												<span class="white--text fs12 " v-if="user.value">{{ $store.getters.users[user.value].value.charAt(0) }}</span>
											</v-avatar>
										</v-list-item-avatar>
										<v-list-item-content>
											<v-list-item-title>{{ user.text }}</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-list>
							<v-card-actions v-if="selectedEvent.id <= 0">
								<v-spacer></v-spacer>
								<v-btn color="primary" class="ma-1" @click="addEvent()" :loading="saved">Salva</v-btn>
							</v-card-actions>
						</v-card>
					</v-menu>
				</v-sheet>

			</v-col>
		</v-row>

		<v-dialog v-model="notPrimaryCalendarDialog" max-width="600" persistent>
			<v-card class="background-2 round-card">
				<v-card-title primary-title class="subtitle-1 background-2">Nessun Calendario Primario</v-card-title>
				<v-divider></v-divider>
				<v-card-text style="min-height: 100px;" class="pt-4 body-2">Non hai configurato nessun calendario come tuo calendario primario.<br> Vai nella sezione Calendari del tuo Profilo e seleziona un calendario come Calendario Primario. <br><br>Se non hai nessun calendario, creane uno e impostalo come Calendario Primario. Dopo puoi tonranre in questa sezione.</v-card-text>
				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click.native.stop="$router.push({path: '/profile/calendars'})" >Profilo</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<confirm-dialog-v-2
			:value.sync="deleteEventDialog"
			mainTitle="Eliminazione evento"
			:secondTitle="eventToDelete ? 'Sei sicuro di voler eliminare l\'evento \'' + eventToDelete.name + '\'?' : ''"
			@confirm="confirmDeleteEvent">
		</confirm-dialog-v-2>
	</v-main>
</template>

<script>

	import CalendarMixin from '@/mixins/CalendarMixin'
	import AppCustomizationMixin from '@/mixins/AppCustomizationMixin'
	import ColorMode from '@/components/common/ColorMode'
	import NotificationsMenu from '@/components/common/NotificationsMenu'
	import EventButtonDialog from '@/components/modules/calendar/EventButtonDialog'
	import EventableEntityCard from '@/components/modules/calendar/EventableEntityCard'
	import EventableDetails from '@/components/modules/calendar/EventableDetails'

	// Righe della fascia "tutto il giorno" (vista giorno/settimana) prima di raccogliere il resto in "+N altri"
	const ALLDAY_MAX_ROWS = 5

	export default {
		name: 'yello-calendar',
		mixins: [CalendarMixin, AppCustomizationMixin],
		components: {
			ColorMode,
			EventableDetails,
			NotificationsMenu,
			EventButtonDialog,
			EventableEntityCard,
		},
		data: () => ({
			drawer: null,
			// title, app_color, logo, headerColor now come from AppCustomizationMixin
			today: moment().format('YYYY-MM-DD'),
			type: localStorage.getItem('calendar_view_type') || 'week',
			fab: false,
			saved: false,
			events: [],
			allDayExpanded: false,
			currentDateMenu: false,
			typeOptions: [
				{ text: 'Giorno', value: 'day' },
				{ text: 'Settimana lavorativa', value: 'work-week' },
				{ text: 'Settimana', value: 'week' },
				{ text: 'Mese', value: 'month' },
			],
			calendars: [],
			users: [],
			eventTypes: [],
			sharedCalendars: [],
			selectedCalendars:[],
			selectAll: false,
			loadEvents: false,
			dragEvent: null,
			dragStart: null,
			createEvent: null,
			createStart: null,
			extendOriginal: null,
			selectedEvent: {},
			selectedElement: null,
			selectedOpen: false,
			notificationEventId: null,
			dummyId: 0,
			loadedEventable: false,
			eventable: {},
			eventParams: {},
			eventableDescription: '',	 
			cloneEvent: {}, 
			ready: false,
			isOwnerEvent: true,
			hasDragged: false,
			timecardCalendar: JSON.parse(localStorage.getItem('timecard_calendar_enabled') || 'false'),
			timecards: [],
			interventionCalendar: JSON.parse(localStorage.getItem('intervention_calendar_enabled') || 'false'),
			interventions: [],
			notPrimaryCalendarDialog:false,
			cancelingEvent: false,
			deleteEventDialog: false,
			eventToDelete: null,
			// Filter properties
			filterPanelOpen: [0],
			selectedEventTypes: [],
			selectedEventableTypes: [],
			// Moved to computed for permission-based filtering
			mobileFilterSheet: false,
		}),

		computed: {

			eventDefaultDurationMinutes() {
				const value = this.$store.getters.getSettingByModel('event', 'event_default_duration_minutes')
				const n = Number(value)
				return Number.isFinite(n) && n >= 5 ? n : 60
			},

			calendarType() {
				// Convert work-week to week type for v-calendar
				return this.type === 'work-week' ? 'week' : this.type
			},

			calendarWeekdays() {
				// For work week, show only Monday to Friday (1-5)
				// For other views, show all days starting from Monday
				return this.type === 'work-week' ? [1, 2, 3, 4, 5] : [1, 2, 3, 4, 5, 6, 0]
			},

			timecardsEvents() {
				return this.events.concat(this.timecards).concat(this.interventions)
			},

			// Nelle viste giorno/settimana gli eventi "tutto il giorno" stanno impilati sopra la griglia
			// senza limite: con 10+ eventi la fascia mangia mezzo schermo. Oltre ALLDAY_MAX_ROWS il resto
			// della giornata finisce in un evento "+N altri" che espande la fascia (e "Mostra meno" la richiude).
			// Gli eventi su più giorni restano sempre visibili: nasconderli toglierebbe la barra da tutti i giorni.
			calendarEvents() {
				const events = this.timecardsEvents
				if (this.type === 'month') return events

				const singleDayAllDay = {}
				events.forEach(e => {
					if (e.timed) return
					const day = moment(e.started_at).format('YYYY-MM-DD')
					if (day !== moment(e.ended_at).format('YYYY-MM-DD')) return
					(singleDayAllDay[day] = singleDayAllDay[day] || []).push(e)
				})

				const hidden = new Set()
				const toggles = []
				Object.keys(singleDayAllDay).forEach(day => {
					const dayEvents = singleDayAllDay[day]
					if (dayEvents.length <= ALLDAY_MAX_ROWS) return
					const collapsed = dayEvents.slice(ALLDAY_MAX_ROWS - 1)
					if (!this.allDayExpanded) collapsed.forEach(e => hidden.add(e))
					toggles.push(this.allDayToggleEvent(day, collapsed.length))
				})
				if (!toggles.length) return events
				return events.filter(e => !hidden.has(e)).concat(toggles)
			},

			activeFiltersCount() {
				return this.selectedEventTypes.length + this.selectedEventableTypes.length
			},

			hasActiveFilters() {
				return this.activeFiltersCount > 0
			},

			eventableTypeOptions() {
				const allTypes = [
					{ value: 'task', label: this.$trans('task'), icon: 'mdi-clipboard-check-outline', permission: 'task' },
					{ value: 'trouble', label: this.$trans('trouble'), icon: 'mdi-ticket-outline', permission: 'trouble' },
					{ value: 'helpdesktrouble', label: this.$trans('helpdesktrouble'), icon: 'mdi-ticket-outline', permission: 'helpdesktrouble' },
					{ value: 'lead', label: this.$trans('lead'), icon: 'mdi-account-search-outline', permission: 'lead' },
					{ value: 'prospect', label: this.$trans('prospect'), icon: 'mdi-account-check', permission: 'prospect' },
					{ value: 'company', label: this.$trans('company'), icon: 'mdi-domain', permission: 'company' },
					{ value: 'opportunity', label: this.$trans('opportunity'), icon: 'mdi-briefcase', permission: 'opportunity' }
				]
				
				// Filter based on model permissions
				return allTypes.filter(type => {
					// Check if user has permission for this model type
					return this.$store.getters.checkModelPermissions(type.permission)
				})
			},
			
			cal() {
				return this.ready ? this.$refs.calendar : null
			},

			nowY() {
				return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
			},

			isEventable() {
				if(this.$route.params.defaultInput) {
					return true
				}
				return false
			},

			eventableUsers() {
				if (!this.isEventable || !this.loadedEventable || !this.users.length) return []
				const entity = this.eventable[this.eventParams.eventable_type]
				if (!entity || !entity.users || !entity.users.length) return []
				return this.users.filter(u =>
					entity.users.some(eu => eu.value === u.value)
				)
			},

			eventableUsersWithoutCalendar() {
				if (!this.isEventable || !this.loadedEventable || !this.users.length) return []
				const entity = this.eventable[this.eventParams.eventable_type]
				if (!entity || !entity.users || !entity.users.length) return []
				const currentUserId = this.$store.getters.getProfile.id
				return entity.users.filter(eu =>
					eu.value !== currentUserId && !this.users.some(u => u.value === eu.value)
				)
			},

			menuClass() {
				return this.$vuetify.breakpoint.xs ? 'mobile-menu' : ''
			},

			primaryCalendar() {
				let primaryCalendar =_.find(this.calendars, (calendar) => calendar.primary == true)
				return primaryCalendar ? primaryCalendar : null
			},

			selectEventCalendars() {
				// Create a new array containing objects from the "calendars" array with the new "type" property
				const calendarsWithType = this.calendars.map((calendar) => {
					return {
						...calendar,
						type: 'Proprietario',
					}
				})

				// Create a new array containing objects from the "sharedCalendars" array with the new "type" property
				const sharedCalendarsWithType = this.sharedCalendars
					.filter(sharedCalendar => ['write', 'write_owner'].includes(sharedCalendar.permission))
					.map(sharedCalendar => ({
						...sharedCalendar,
						type: 'Condiviso',
					}))

				// Concatenate the two arrays
				return calendarsWithType.concat(sharedCalendarsWithType);
			},


			durationMinutes(started_at, ended_at) {
				return (started_at, ended_at) => {
					return moment.duration(moment(ended_at).diff(started_at)).asMinutes()
				}
			},		

		},


		methods: {
			// setCustomAppData, getCustomAppData, setLogo methods now come from AppCustomizationMixin
			goBack() {
				if (window.history.length > 1) {
					this.$router.back()
				} else {
					this.$router.push('/')
				}
			},
			updateEventAllDay() {
				// When switching to all-day, adjust times
				if (this.selectedEvent.allday) {
					// Set timed to false for all-day events
					this.selectedEvent.timed = false
				} else {
					// Set timed to true for timed events
					this.selectedEvent.timed = true
				}
			},

			isToday(date) {
				const today = new Date()
				const checkDate = new Date(date)
				return today.getFullYear() === checkDate.getFullYear() &&
					today.getMonth() === checkDate.getMonth() &&
					today.getDate() === checkDate.getDate()
			},

			getEventTypeText(eventTypeValue) {
				if (!eventTypeValue) return ''
				if (!this.eventTypes || this.eventTypes.length === 0) return eventTypeValue
				const eventType = this.eventTypes.find(type => type.value === eventTypeValue)
				return eventType ? eventType.text : eventTypeValue
			},

			hasPermissions(event) {
				// ho i permessi sono sugli eventi
				if(event.type === 'event') {

					if(event.calendar.user_id === this.$store.getters.getProfile.id) {
						return true
					}
					
					if(event.calendar.permission) {
						if(event.calendar.permission == 'write') {
							return true
						}
						if(event.user_id === this.$store.getters.getProfile.id && event.calendar.permission == 'write_owner') {
							return true
						}
						if(!event && event.calendar.permission == 'write_owner') {
							return true
						}
					}
				}
				return false
			},

			removeEventable() {
				this.loadedEventable = false
				this.eventParams = {}
				this.eventable = {}
			},

			viewDay({ date }) {
				this.value = date
				this.type = 'day'
			},
			handleDateClick(dateData) {
				// Extract date from dateData
				const date = dateData.date || dateData
				const event = dateData.nativeEvent || window.event

				// In month view, only open day view when clicking the day number
				if (this.type === 'month') {
					// Check if we clicked on the day number button
					if (event) {
						const target = event.target
						if (target && (target.classList.contains('v-btn__content') || target.closest('.v-btn'))) {
							this.viewDay({ date })
						}
					}
					// Otherwise, handleDayClick will handle creating all-day events
				} else {
					// In other views, always open day view
					this.viewDay({ date })
				}
			},
			handleDayClick(dayData) {
				// Extract date and event from dayData
				const date = dayData.date || dayData
				const event = dayData.nativeEvent || window.event

				// Don't create event if clicking on day number button or existing events
				if (event) {
					const target = event.target
					if (target && (target.classList.contains('v-btn__content') ||
						target.closest('.v-btn') ||
						target.closest('.v-event'))) {
						return
					}
				}

				// Check if primary calendar exists
				if (!this.primaryCalendar) {
					this.$store.commit('setSnackbar', {
						timeout: 6000,
						text: 'Seleziona prima un calendario primario',
						value: true,
						color: 'error'
					})
					return
				}

				// Create all-day event
				const startDate = moment(date).startOf('day')
				const endDate = moment(date).endOf('day')

				this.selectedEvent = {
					id: --this.dummyId,
					name: this.setEventTitle,
					allday: true,
					timed: false,
					started_at: startDate.valueOf(),
					ended_at: endDate.valueOf(),
					calendar_id: this.primaryCalendar.id,
					calendar: this.primaryCalendar,
					type: 'event',
					eventable_type: this.eventParams?.eventable_type,
					eventable_id: this.eventParams?.eventable_id,
					users: this.eventableUsers
				}

				// Open the event creation dialog
				this.selectedElement = event ? event.target : null
				this.selectedOpen = true
			},

			getCurrentTime() {
				return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
			},

			updateTime() {
				setInterval(() => this.cal.updateTimes(), 60 * 1000)
			},

			prev() {
				this.$refs.calendar.prev()
				this.getEvents()
			},

			next() {
				this.$refs.calendar.next()
				this.getEvents()
			},

			setToday() {
				if(this.today !=  moment().format('YYYY-MM-DD')) {
					this.today = moment().format('YYYY-MM-DD')
					this.getEvents()
				}
			},

			closeMenu() {
				this.selectedOpen = false
				this.selectedElement = null
				this.selectedEvent = null
			},

			deleteAndClose(event) {
				let	deleteEvent = _.findIndex(this.events, (e) => event.id  == e.id)
				let	ev = _.find(this.events, (e) => event.id  == e.id)
				if(deleteEvent >= 0) {
					if(ev.id <= 0) {
						this.events.splice(deleteEvent, 1)
						// Imposta il flag per evitare la creazione immediata di un nuovo evento
						this.cancelingEvent = true
						setTimeout(() => {
							this.cancelingEvent = false
						}, 300)
					}
					this.createEvent = null
					this.dragEvent = null
					this.cloneEvent = null
					this.selectedOpen = false
					this.selectedElement = null
					this.selectedEvent = null
				} else if (event && event.id <= 0) {
					// Handle events created via day cell click that aren't in the events array
					this.cancelingEvent = true
					setTimeout(() => {
						this.cancelingEvent = false
					}, 300)
					this.createEvent = null
					this.dragEvent = null
					this.cloneEvent = null
					this.selectedOpen = false
					this.selectedElement = null
					this.selectedEvent = null
				}
			},

			quickAddEvent() {
				this.saved = true
				this.createEvent.name = this.createEvent.name === '' || !this.createEvent.name ? '(Senza titolo)' : this.createEvent.name
				this.createEvent.type = this.type
				// Ensure allday is properly set (default to false if not set)
				if (this.createEvent.allday === undefined) {
					this.createEvent.allday = false
				}
				this.axios.post('events', this.createEvent).then(response => {
					this.saved = false
					this.dragTime = null
					this.dragEvent = null
					this.createEvent = null
					this.createStart = null
					this.extendOriginal = null

					this.getEvents()
					this.$store.commit('setSnackbar', {timeout: 6000, text: response.message, value: true, color: 'success'})
					this.selectedOpen = false
				},
				response => {
					// error callback
					this.saved = false
				})
			},
			
			addEvent() {
				this.saved = true
				this.selectedEvent.name = this.selectedEvent.name === '' || !this.selectedEvent.name ? '(Senza titolo)' : this.selectedEvent.name
				this.selectedEvent.type = this.type
				// Ensure allday is properly set (default to false if not set)
				if (this.selectedEvent.allday === undefined) {
					this.selectedEvent.allday = false
				}
				this.axios.post('events', this.selectedEvent).then(response => {
					this.saved = false
					this.selectedOpen = false
					setTimeout(() => {
						this.selectedEvent = null
						this.createEvent = null
					}, 100)

					this.getEvents()
					this.$store.commit('setSnackbar', {timeout: 6000, text: response.data.message, value: true, color: response.data.status})
				},
				response => {
					// error callback
					this.saved = false
				})
			},

			quickUpdateEvent() {
				this.saved = true
				this.dragEvent.type = this.type
				let dataObject = { ...this.dragEvent }
				this.dragTime = null
				this.dragEvent = null
				this.createEvent = null
				this.createStart = null
				this.extendOriginal = null
				this.cloneEvent = null		

				this.axios.put('events/' + dataObject.id, dataObject).then(response => {
					
					this.saved = false

					this.getEvents()
					this.$store.commit('setSnackbar', {timeout: 6000, text: response.data.message, value: true, color: response.data.status})
				},
				response => {
					// error callback
				})
			},

			deleteEvent(event) {
				this.eventToDelete = event
				this.deleteEventDialog = true
			},

			confirmDeleteEvent() {
				if (!this.eventToDelete) return
				this.axios.post('events/delete', {ids: [this.eventToDelete.id]}).then(response => {
					this.selectedOpen = false
					this.deleteEventDialog = false
					this.eventToDelete = null
					this.getEvents()
					this.$store.commit('setSnackbar', {timeout: 6000, text: response.data.message, value: true, color: response.data.status})
				}, response => {
					// error callback
					this.deleteEventDialog = false
					this.eventToDelete = null
				})
			},		

			allDayToggleEvent(day, hiddenCount) {
				const start = moment(day).startOf('day').valueOf()
				return {
					id: 'allday-toggle-' + day,
					allDayToggle: true,
					name: this.allDayExpanded ? 'Mostra meno' : '+' + hiddenCount + ' altri',
					allday: true,
					timed: false,
					started_at: start,
					ended_at: moment(day).endOf('day').valueOf(),
					calendar: { color: '#E0E0E0' },
				}
			},

			showEvent({ nativeEvent, event }) {
				if (event.allDayToggle) {
					this.allDayExpanded = !this.allDayExpanded
					nativeEvent.stopPropagation()
					return
				}
				const open = () => {
					this.selectedEvent = event
					this.selectedElement = nativeEvent.target
					requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
				}
				if (this.selectedOpen) {
					this.selectedOpen = false
					requestAnimationFrame(() => requestAnimationFrame(() => open()))
				} else {
					open()
				}
				nativeEvent.stopPropagation()
			},

			openNotificationEvent() {
				if (!this.notificationEventId) return
				let eventId = this.notificationEventId
				let event = this.events.find(e => e.id === eventId)
				if (!event) return
				this.$nextTick(() => {
					let el = document.getElementById(eventId)
					if (el) {
						this.notificationEventId = null
						this.selectedEvent = event
						this.selectedElement = el
						requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
					}
				})
			},

			startDrag({ event, timed, nativeEvent }) {
				// Ignora il click del tasto destro
				if(nativeEvent && nativeEvent.button !== 0) return
				
				if (event && timed) {
					if(this.hasPermissions(event) && !event.event_id) {
						this.$set(this, 'dragEvent', event)
						this.dragTime = null
						this.extendOriginal = null
						this.cloneEvent = {...event}
					} else {
						this.isOwnerEvent = false
					}
				}
			},

			open(nativeEvent, event) {
				this.selectedEvent = event
				this.selectedElement = nativeEvent.target
				setTimeout(() => {
					this.selectedOpen = true
					this.createEvent = null
					this.createStart = null
					this.dragTime = null
					this.dragEvent = null				
				}, 100)
			},

			endDrag() {
				// se non ho spostato l'evento ma ci ho solo cliccato sopra lasciandolo dove stava
				if(this.dragEvent != null && JSON.stringify(this.cloneEvent) == JSON.stringify(this.dragEvent) || this.createEvent != null && JSON.stringify(this.cloneEvent) == JSON.stringify(this.createEvent)) {
					this.createEvent = null
					this.createStart = null
					this.dragTime = null
					this.dragEvent = null
				} else {
					// se smetto di spostare evento già esistente
					if((this.dragEvent && this.dragEvent.id > 0)) {
						this.quickUpdateEvent()
					}
					// se provo a spostare un evento non mio
					else if(this.isOwnerEvent == false) {
						if (this.hasDragged) {
							this.$store.commit('setSnackbar', {timeout: 6000, text: 'Non puoi spostare questo evento', value: true, color: 'black'})
						}
						this.isOwnerEvent = true
					}
					// se smetto di spostare evento nuovo
					else if(this.createEvent && this.createEvent.id <= 0) {	
						this.open(event, {...this.createEvent})

					// se smetto di ridimensionare evento esistente
					} else if(this.createEvent && this.createEvent.id > 0) {
						this.dragEvent = this.createEvent
						this.quickUpdateEvent()
					}
				}
				this.hasDragged = false
			},

			startTime(tms, event) {
				// Ignora il click del tasto destro
				if(event && event.button !== 0) return
				
				// Se c'è un menu aperto, chiudilo e non creare un nuovo evento
				if(this.selectedOpen) {
					// Se c'è un evento selezionato non salvato, eliminalo
					if(this.selectedEvent && this.selectedEvent.id <= 0) {
						this.deleteAndClose(this.selectedEvent)
					} else {
						this.closeMenu()
					}
					return
				}
				
				// Se stiamo annullando un evento, ignora questo click
				if(this.cancelingEvent) {
					this.cancelingEvent = false
					return
				}
				
				if(this.selectedEvent)
					this.deleteAndClose(this.selectedEvent)
					
				const mouse = this.toTime(tms)

				if (this.dragEvent && this.dragTime === null) {
					const started_at = this.dragEvent.started_at

					this.dragTime = mouse - started_at

				} else if(this.isOwnerEvent) {

					this.createStart = this.roundTime(mouse)
					const durationMs = this.eventDefaultDurationMinutes * 60 * 1000
					this.createEvent = {
						name: this.setEventTitle,
						color: this.primaryCalendar.color,
						started_at: this.createStart,
						ended_at: this.createStart + durationMs,
						timed: true,
						allday: false,
						calendar: this.primaryCalendar,
						calendar_id: this.primaryCalendar.id,
						id: --this.dummyId,
						eventable_type: this.eventParams.eventable_type,
						eventable_id: this.eventParams.eventable_id,
						type: 'event',
						users: this.eventableUsers
					}
					this.events.push(this.createEvent)
				} 
			},

			extendBottom(event) {
				this.createEvent = event
				this.createStart = event.started_at
				this.extendOriginal = event.ended_at
				this.cloneEvent = {...event}
			},

			mouseMove(tms) {
				const mouse = this.toTime(tms)

				// in move mode
				if (this.dragEvent && this.dragTime !== null) {
					this.hasDragged = true
					const started_at = this.dragEvent.started_at
					const ended_at = this.dragEvent.ended_at
					const duration = ended_at - started_at
					const newStartTime = mouse - this.dragTime
					const newStart = this.roundTime(newStartTime)
					const newEnd = newStart + duration

					this.dragEvent.started_at = newStart
					this.dragEvent.ended_at = newEnd

				// in extended mode
				} else if (this.createEvent && this.createStart !== null) {
					this.hasDragged = true
					const mouseRounded = this.roundTime(mouse, false)
					const min = Math.min(mouseRounded, this.createStart)
					const max = Math.max(mouseRounded, this.createStart)

					this.createEvent.started_at = min
					this.createEvent.ended_at = max
				} else if (!this.isOwnerEvent) {
					this.hasDragged = true
				}
			},


			cancelDrag() {

				// if (this.createEvent) {
				// 	if (this.extendOriginal) {
				// 		this.createEvent.ended_at = this.extendOriginal
				// 	} else {
				// 		const i = this.events.indexOf(this.createEvent)
				// 		if (i !== -1) {
				// 		this.events.splice(i, 1)
				// 		}
				// 	}
				// }

				this.createEvent = null
				this.createStart = null
				this.dragTime = null
				this.dragEvent = null
			},

			roundTime(time, down = true) {
				const roundTo = 15 // minutes
				const roundDownTime = roundTo * 60 * 1000

				return down
				? time - time % roundDownTime
				: time + (roundDownTime - (time % roundDownTime))
			},

			toTime(tms) {
				return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
			},

			getEventColor (event) {
				if(event.calendar) {
					return event.calendar.color
				} else {
					return 'primary'
				}
			},

			isPastEvent(event) {
				// Controlla se l'evento è nel passato
				const now = new Date()
				const eventEnd = new Date(event.ended_at)

				// Se l'evento è terminato, è nel passato
				return eventEnd < now
			},

			copyInClipboard(event) {
				const lines = [
					event.name,
					this.formatEventDate(event).replace(/\b\w/g, l => l.toUpperCase()),
					event.creator,
				]
				if (event.vehicles && event.vehicles.length) {
					lines.push('Veicoli: ' + event.vehicles.map(v => v.text).join(', '))
				}
				navigator.clipboard.writeText(lines.filter(Boolean).join('\n'))
			},

			// Filter methods
			clearFilters() {
				this.selectedEventTypes = []
				this.selectedEventableTypes = []
				this.saveFilterPreferences()
				this.getEvents()
			},

			applyFilters() {
				this.saveFilterPreferences()
				this.getEvents()
			},

			removeEventType(item) {
				const index = this.selectedEventTypes.indexOf(item.value)
				if (index > -1) {
					this.selectedEventTypes.splice(index, 1)
				}
			},

			saveFilterPreferences() {
				localStorage.setItem('calendar_filter_event_types', JSON.stringify(this.selectedEventTypes))
				localStorage.setItem('calendar_filter_eventable_types', JSON.stringify(this.selectedEventableTypes))
				localStorage.setItem('calendar_filter_panel_open', JSON.stringify(this.filterPanelOpen))
				// Save selected view type
				localStorage.setItem('calendar_view_type', this.type)
			},

			loadFilterPreferences() {
				// View type is now loaded in data initialization

				// Load event type filters
				const savedEventTypes = localStorage.getItem('calendar_filter_event_types')
				if (savedEventTypes) {
					try {
						this.selectedEventTypes = JSON.parse(savedEventTypes)
					} catch (e) {
						this.selectedEventTypes = []
					}
				}

				// Load eventable type filters
				const savedEventableTypes = localStorage.getItem('calendar_filter_eventable_types')
				if (savedEventableTypes) {
					try {
						this.selectedEventableTypes = JSON.parse(savedEventableTypes)
					} catch (e) {
						this.selectedEventableTypes = []
					}
				}

				// Load panel open state
				const savedPanelState = localStorage.getItem('calendar_filter_panel_open')
				if (savedPanelState) {
					try {
						this.filterPanelOpen = JSON.parse(savedPanelState)
					} catch (e) {
						this.filterPanelOpen = []
					}
				}
			},

			getEvents() {
				this.loadEvents = true
				this.calcIntervalDate()
				let options = {
					from: this.from,
					to: this.to,
					calendars: this.selectedCalendars,
				}
				
				// Add event type filters if selected
				if (this.selectedEventTypes.length > 0) {
					options.event_types = this.selectedEventTypes
				}
				
				// Add eventable type filters if selected
				if (this.selectedEventableTypes.length > 0) {
					options.eventable_types = this.selectedEventableTypes
				}

				this.axios.post('events-filters', {'subFilters': options}).then(response => {
					if(response.data.data.length == 0) {
						this.events = []
					} else {
						this.events = response.data.data
					}
					this.loadEvents = false
					this.$store.commit('endProgress')
					this.openNotificationEvent()
				},
				response => {
					// error callback
				})

				this.getTimecards()
				this.getInterventions()
			},

			getTimecards() {
				if(this.timecardCalendar && this.$store.getters.checkModulePermissions('timecards')) {
					this.loadEvents = true
					this.calcIntervalDate()
					let options = {
						from: this.from,
						to: this.to,
						kind: 'timecard',
					}

					this.axios.post('event-timecards-filters', {'subFilters': options}).then(response => {
						if(response.data.data.length == 0) {
							this.timecards = []
						} else {
							this.timecards = response.data.data
						}
						this.loadEvents = false
						this.$store.commit('endProgress')
					},
					response => {
						// error callback
					})
				}
			},

			getInterventions() {
				if(this.interventionCalendar && this.$store.getters.checkModulePermissions('tickets')) {
					this.loadEvents = true
					this.calcIntervalDate()
					let options = {
						from: this.from,
						to: this.to,
						kind: 'intervention',
					}

					this.axios.post('event-timecards-filters', {'subFilters': options}).then(response => {
						if(response.data.data.length == 0) {
							this.interventions = []
						} else {
							this.interventions = response.data.data
						}
						this.loadEvents = false
						this.$store.commit('endProgress')
					},
					response => {
						// error callback
					})
				}
			},

		},


		watch: {
			selectAll: {
				handler(newValue, oldValue) {
					localStorage.setItem('selected_calendars', JSON.stringify([]))
					if(newValue) {
						_.forEach(this.calendars.concat(this.sharedCalendars), (calendar) => {
							if(!this.selectedCalendars.includes(calendar.id)) {
								this.selectedCalendars.push(calendar.id)
							}
						})
					} else {
						this.selectedCalendars = []
					}
				}
			},

			selectedCalendars: {
				handler(newValue, oldValue) {
					localStorage.setItem('selected_calendars', JSON.stringify(this.selectedCalendars))
					this.getEvents()
				}
			},
			
			timecardCalendar: {
				handler(newValue, oldValue) {
					localStorage.setItem('timecard_calendar_enabled', JSON.stringify(newValue))
					if(newValue) {
						this.getTimecards()
					} else {
						this.$set(this, 'timecards', [])
					}
				}
			},

			interventionCalendar: {
				handler(newValue, oldValue) {
					localStorage.setItem('intervention_calendar_enabled', JSON.stringify(newValue))
					if(newValue) {
						this.getInterventions()
					} else {
						this.$set(this, 'interventions', [])
					}
				}
			},

			type: {
				handler(newValue, oldValue) {
					// Save view type when it changes
					localStorage.setItem('calendar_view_type', newValue)

					// Scroll to current time
					if (this.$refs.calendar) {
						this.$refs.calendar.scrollToTime(moment().format('HH:mm'))
					}
					// Don't call getEvents() here - the calendar @change event will trigger it
				}
			},

		},

		mounted () {
			if(!this.$store.getters.checkModulePermissions('calendar')) {
				this.$router.back()
				return
			}

			this.$eventBusUtility.$on('refreshCalendar', () => {
				this.getEvents()
			})
			
			this.$refs.calendar.scrollToTime(moment().format('HH:mm'))

			document.onkeydown = evt => {
				evt = evt || window.event
				if (evt.keyCode == 27) {
					if(!_.isEmpty(this.selectedEvent)) {
						this.deleteAndClose(this.selectedEvent)
					} else {
						this.selectedOpen = false
					}
				}
			}

			if(this.isEventable) {
				this.eventParams = this.$route.params.defaultInput
				this.axios.get(this.eventParams.url + '/' + this.eventParams.eventable_id).then(response => {
					this.eventable = response.data.models
					this.loadedEventable = true
				},
				response => {
				
				})
			}
			// disabled right click
			// window.addEventListener('contextmenu', function (e) { 
			// 	// do something here... 
			// 	e.preventDefault(); 
			// }, false);

			this.ready = true
			this.updateTime()		
		},

		created() {
			this.getCustomAppData()
			//if notification provenance
			let eventPromise = null
			if(!this.isEventable && this.$route.query.event_id) {
				let eventId = this.$route.query.event_id
				this.notificationEventId = parseInt(eventId)
				eventPromise = this.axios.get('events/' + eventId).then(response => {
					let startedAt = response.data.started_at
					this.today = typeof startedAt === 'string' ? startedAt.substring(0, 10) : new Date(startedAt).toISOString().substring(0, 10)
					this.type = 'day'
				}).catch(() => {})
			} else if(!this.isEventable && this.$route.params.id) {
				eventPromise = this.axios.get('events/' + this.$route.params.id).then(response => {
					let startedAt = response.data.started_at
					this.today = typeof startedAt === 'string' ? startedAt.substring(0, 10) : new Date(startedAt).toISOString().substring(0, 10)
				}).catch(() => {})
			}
			let infoPromise = this.axios.get('events-info').then(response => {
				// get body data
				this.calendars = response.data.fields.calendars
				if(!this.primaryCalendar) {
					this.notPrimaryCalendarDialog = true
				}
				this.users = response.data.fields.users
				// 'planner' type is reserved for events created from the Planner UI only.
				this.eventTypes = (response.data.fields.event_types || []).filter(t => t.value !== 'planner')
				this.sharedCalendars = response.data.fields.shared_calendars
				this.presetSelectedCalendars()
				this.loadFilterPreferences()  // Load saved filter preferences
			}).catch(() => {})
			Promise.all([eventPromise, infoPromise].filter(Boolean)).then(() => {
				this.getEvents()
			})
		},	

	}
</script>
<style>

	.yello-calendar .v-date-picker-header__value  button {
		text-transform: capitalize !important;
	}
	/* Calendar day cell hover effect for all views */
	.v-calendar-monthly .v-calendar-weekly__day,
	.v-calendar-weekly .v-calendar-weekly__day,
	.v-calendar-daily .v-calendar-daily__day {
		cursor: pointer;
		transition: background-color 0.2s;
	}
	.v-calendar-monthly .v-calendar-weekly__day:hover,
	.v-calendar-weekly .v-calendar-weekly__day:hover,
	.v-calendar-daily .v-calendar-daily__day:hover {
		background-color: rgba(0, 0, 0, 0.02);
	}
	.theme--dark .v-calendar-monthly .v-calendar-weekly__day:hover,
	.theme--dark .v-calendar-weekly .v-calendar-weekly__day:hover,
	.theme--dark .v-calendar-daily .v-calendar-daily__day:hover {
		background-color: rgba(255, 255, 255, 0.05);
	}
	/* Don't show hover on day number buttons */
	.v-calendar-monthly .v-calendar-weekly__day-label .v-btn:hover,
	.v-calendar-weekly .v-calendar-weekly__day-label .v-btn:hover {
		background-color: transparent !important;
	}
	.monthly-event-menu-pin {
		border-radius: 4px;
		height: 16px;
		width: 16px;
		margin-left: 3px;
		margin-right: 21px;
		margin-top: 3px;
	}
	.v-calendar-daily__interval-text {
		color: #70757a !important;
	}
	/* .v-calendar-daily__body {
		height: calc(100vh - 143px);
	}
	.v-calendar-monthly {
		height: calc(100vh - 64px);
	} */
	.v-calendar-daily__head {
		width: calc(100% - 8px);
	}
	.event-title {
		white-space: initial !important;
		font-weight: 600;
	}
	.event-schedule {
		white-space: initial !important;
	}
	.mobile-menu {
		width: 100% !important;
		height: 100% !important;
		max-width: 100% !important;
	}
	.dark-calendar > .v-navigation-drawer__content{
		border-top: #9e9e9e 1px solid;
	}
	.calendar > .v-navigation-drawer__content{
		border-top: #e0e0e0 1px solid;
	}
	.v-calendar-daily_head-day-label-new {
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		padding: 0px 0px 3px 0px;
		cursor: pointer;
		text-align: center;
	}
	.v-calendar-daily_head-day-label > .v-btn {
		height: 40px;
		width: 40px;
		min-width: 40px !important;
	}
    .avatar-event {
        margin-left: -14px;
        border-radius: 50% !important;
        background-size: cover !important;
        background-position: center !important;
    }
	.yello-calendar .v-date-picker-table {
		height: 210px !important;
	}
	.v-event-draggable {
		padding-left: 6px;
	}
	.v-event-timed {
		user-select: none;
		-webkit-user-select: none;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis	
	}
	.v-event-drag-bottom {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 4px;
		height: 4px;
		cursor: ns-resize;
	}
	.v-event-drag-bottom::after {
		display: none;
		position: absolute;
		left: 50%;
		height: 4px;
		border-top: 1px solid white;
		border-bottom: 1px solid white;
		width: 16px;
		margin-left: -8px;
		opacity: 0.8;
		content: '';
	}
	.v-event-drag-bottom:hover::after {
		display: block;
	}
	.v-current-time {
		height: 2px;
		background-color: #ea4335;
		position: absolute;
		left: -1px;
		right: 0;
		pointer-events: none;
	}
	.v-current-time.first::before {
		content: '';
		position: absolute;
		background-color: #ea4335;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		margin-top: -5px;
		margin-left: -6.5px;
	}
	.event {
		white-space: initial !important;
	}
	.past-event {
		opacity: 0.5;
	}
	.v-calendar-monthly-day {
		cursor: pointer;
		width: 100%;
		height: 100%;
		position: relative;
	}
	.v-calendar-monthly-day-number {
		display: inline-block;
		padding: 4px 8px;
		cursor: pointer;
		border-radius: 4px;
		transition: background-color 0.2s;
	}
	.v-calendar-monthly-day-number:hover {
		background-color: rgba(0, 0, 0, 0.05);
	}
	.theme--dark .v-calendar-monthly-day-number:hover {
		background-color: rgba(255, 255, 255, 0.1);
	}
	.v-calendar-monthly .v-calendar-weekly__day {
		min-height: 80px;
	}
</style>